"use client";

import React from "react";

import { ChevronLeft } from "@/components/icons/ChevronLeft";
import { ChevronRight } from "@/components/icons/ChevronRight";

type ArrowSharedProps = {
  disabled: boolean;
  arrowButtonClassName: string;
};

export type SliderArrowPreviousProps = ArrowSharedProps & {
  scrollPrev: () => void;
};

export type SliderArrowNextProps = ArrowSharedProps & {
  scrollNext: () => void;
};

export const SliderArrowPrevious: React.FC<SliderArrowPreviousProps> = ({
  scrollPrev,
  disabled,
  arrowButtonClassName,
}) => (
  <button
    type="button"
    className={arrowButtonClassName}
    onClick={scrollPrev}
    aria-label="Previous slide"
    disabled={disabled}
  >
    <ChevronLeft />
  </button>
);

export const SliderArrowNext: React.FC<SliderArrowNextProps> = ({
  scrollNext,
  disabled,
  arrowButtonClassName,
}) => (
  <button
    type="button"
    className={arrowButtonClassName}
    onClick={scrollNext}
    aria-label="Next slide"
    disabled={disabled}
  >
    <ChevronRight />
  </button>
);
